import React from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import ReactApexChart from "react-apexcharts"

const Performance = props => {
  const { options, series } = props
  return (
    <React.Fragment>
      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="d-flex flex-wrap">
              <h5 className="card-title me-2">Performance</h5>
              <div className="ms-auto">
                <div className="toolbar d-flex flex-wrap gap-2 text-end">
                  {/* <button type="button" className="btn btn-light btn-sm">
                    Day
                  </button>{" "} */}
                  <button type="button" className="btn btn-light btn-sm">
                    Current Week
                  </button>{" "}
                  {/* <button type="button" className="btn btn-light btn-sm active">
                    Year
                  </button>{" "}
                  <button type="button" className="btn btn-light btn-sm">
                    <i className="fas fa-cloud-download-alt"></i>
                  </button>{" "} */}
                </div>
              </div>
            </div>

            <hr className="mb-4" />
            <div id="area-chart" dir="ltr">
              <ReactApexChart
                options={options}
                series={series}
                type="area"
                height={350}
                className="apex-charts"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}



export default Performance
